<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3 class="text-center">Resources</h3>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-space-betwwen>
        <v-btn small link href="/resources/drugs" @click.stop.prevent="goTo('/resources/drugs')" title="Drugs">Drugs</v-btn>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/Guest'

  export default {
    name: 'ResourcesIndex',
    layout,
    props: [],
    components: {},
    metaInfo () {
      return {
        title: 'Resources',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {}
    },
    methods: {
      somemethod () {},
    },
    created () {
      // this.somemethod()
    },
    computed: {},
    watch: {
      '$route': 'somemethod',
    }
  }
</script>
